import moment from 'moment';

export const isOvernightFlight = (depDatetimeLocal: string, arrDatetimeLocal: string) => {
    const depDate = moment(depDatetimeLocal);
    const arrDate = moment(arrDatetimeLocal);

    return !depDate.isSame(arrDate, 'day');
};

